import AEMWrapper from "aem/ComponentWrapper";
import meta from "./aem-meta";
import Component from "./aem-component";

export default AEMWrapper(meta, Component);
